const state = () => ({
    wxRule:'',
})
const getters = {}
const mutations = {
    setWxRule(state,value){
        state.wxRule = value
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
